module.exports = __webpack_public_path__ + "img/cotiza.06046bbc.jpg";